/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Voltar',
      changePassword: 'Alterar Palavra-passe',
      copiedVaultId: 'Copiado!',
      copyVaultID: 'Copiar ID Vault',
      create: 'Criar',
      next: 'Seguinte',
      notSure: 'Não tenho a certeza',
      signUp: 'Inscreva-se',
      submit: 'Submeter',
      updatePassword: 'Atualizar senha',
    },
    Errors: {
      createReportFailed: 'Falha ao criar relatório.',
    },
    ReportStatus: {
      CLOSED: 'Fechado',
      INVESTIGATING: 'Em Investigação',
      NEW: 'Submetido',
      READ: 'Lido',
    },
    general: {
      navbar: {
        caseSettings: 'Configurações de caso',
        changePassword: 'Alterar senha',
        logOut: 'Terminar sessão',
        notifications: 'Notificações',
        notificationsDrawer: {
          appFileScanFailed: 'Um arquivo falhou na verificação de segurança',
          appReportMatch: 'O seu registo GoTogether foi correspondido',
          appReportReassigned: 'Foi atribuído um novo gestor de caso',
          case: 'Caso',
          caseAssigned: 'Caso atribuído a você',
          caseImporterJobCompleted: {
            PartialSuccess: 'A importação do seu caso foi concluída com erros',
            failure: 'A importação do seu caso falhou',
            success: 'A importação do seu caso foi concluída com sucesso',
          },
          caseLinked: 'Caso ligado',
          caseTeamInvite: 'Adicionado ao caso',
          caseUnlinked: 'Caso desvinculado',
          dataSanitisation: 'Detalhes do relatório atualizados',
          emptyDescription: 'Verifique mais tarde para novas notificações',
          emptyTitle: 'Estás completamente atualizado',
          importId: 'ID de importação:',
          learnMore: 'Aprenda mais',
          markAllAsRead: 'Marcar tudo como lido',
          newMessage: 'Nova mensagem',
          newReport: 'Novo relatório recebido',
          permissionRemoved: 'Removido do caso',
          postSSubmissionFile: 'Ficheiro(s) de evidências adicionado(s)',
          report: 'Relatório',
          reportAssigned: 'Relatório atribuído a você',
          reportStatusChange: 'Estado do relatório alterado',
          reporterAnonymised: 'Os seus detalhes foram anonimizados',
          reporterReportSubmitted: {
            subtitle: 'Recomendamos que guarde uma cópia do seu relatório',
            title: 'Relatório submetido',
          },
          mitigationPlanReminder: 'Aprovação do plano de mitigação necessária',
          staleCase: 'Caso não acionado',
        },
        privacyStatement: 'Declaração de privacidade',
        reporter: {
          myReports: 'Os meus relatórios',
        },
        settings: 'Configurações',
        technicalSupport: 'Suporte técnico',
        title: 'Conta',
      },
      time: {
        day: 'Dia',
        days: 'Dias',
        hour: 'Hora',
        hours: 'Horas',
        minute: 'Minuto',
        minutes: 'Minutos',
        second: 'Segundo',
        seconds: 'Segundos',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anónimo',
        autoTranslate: 'A tradução automática está desativada por padrão.',
        backToMessages: 'Voltar às mensagens',
        caseSettings: 'Configurações do caso.',
        changeInProfile:
          'Se desejar alterar esta configuração, pode fazê-lo no seu perfil',
        deletedByMessage: 'Eliminado por {{author}}',
        deletedMessageLabel: 'Esta mensagem foi apagada',
        description:
          'Quando a auto-tradução está ativada, todas as mensagens do relatório serão\n          automaticamente traduzidas usando IA com base no idioma padrão\n          selecionado no seu navegador.',
        descriptionSecondHalf:
          'A versão original de todas as mensagens é sempre preservada e pode ser encontrada no chat.',
        messagePlaceholder: 'Comece a digitar...',
        messageSettings: 'Configurações de mensagem.',
        originalMessages: 'Original',
        showMoreBanner: 'Saiba mais sobre traduções automáticas',
        titlev2: 'Leia todas as mensagens no seu idioma preferido.',
        translatedMessageLabel: 'Mensagem Traduzida',
        translatedMessages: 'Traduzido',
        understood: 'Entendido',
      },
      Country: {
        description: 'Em que país está sediado?',
        header: 'Em que país está sediado?',
        noOptions: 'Nenhum país encontrado',
        other: 'Outro',
        placeholder: 'Procurar um país...',
      },
      CreatePublicReport: {
        createReport: 'Criar novo relatório',
        helpPage: 'Vá para a nossa página de ajuda',
        loginToOpr: 'Iniciar sessão para Acompanhar Relatórios',
        or: 'ou',
        passwordPlaceholder: 'Introduza a palavra-passe',
        phoneNumberLoginFailed:
          'Falha no login, número de telefone/pin incorrecto',
        phoneNumberPlaceholder: 'Insira o seu Número de Telefone',
        phoneNumberTooltip:
          'Insira o número de telefone que usou para entrar em contato com VaultTalk',
        pinPlaceholder: 'Insira o Pin',
        reportIntroductionParagraph1:
          'Ao relatar um incidente, serão feitas algumas perguntas para ajudá-lo a documentar a sua experiência.',
        reportIntroductionParagraph2:
          'Antes de submeter, tem a opção de permanecer anónimo para proteger a sua privacidade.',
        reportIntroductionParagraph3:
          'Depois de submeter, pode entrar a qualquer momento para ver o progresso do seu relatório e conversar com um gestor de caso.',
        reportIssue: 'Reportar um problema',
        usernameLoginFailed: 'Falha no login, nome de usuário/senha incorretos',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'É necessário indicar a relação com a empresa',
            reportedCategoryRequired: 'A categoria reportada é necessária',
          },
        },
        vaultId: 'ID de Vault',
        vaultIdPlaceholder: 'Insira o seu Email ou ID Vault',
        vaultIdTooltip:
          'Para relatórios anónimos, o ID do Vault é alfanumérico. Se o relatório não foi anónimo, o ID do Vault é o seu endereço de email.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'A sua senha',
        yourPhoneNumber: 'O Seu Número de Telefone',
        yourPin: 'O seu PIN de 6 dígitos',
        yourVaultId: 'O seu ID de Vault',
      },
      CustomHeader: {
        companyLogo: 'Logótipo da empresa',
        openReporting: 'Abrir relatório',
        userSettings: 'Definições de utilizador',
      },
      Date: {
        approximateDescription:
          'Lembra-se da data aproximada em que o evento ocorreu?',
        approximatePlaceholder:
          'Exemplo: há 6 meses / no ano passado / em novembro',
        cancel: 'cancelar',
        clear: 'limpar',
        description: 'Lembra-se da data em que o evento ocorreu?',
        header: 'Em que dia ocorreu?',
        ok: 'ok',
        placeholder: 'Exemplo: 21 de junho de 2020',
      },
      Description: {
        whatHappened: 'O que aconteceu?',
        whatHappenedPlaceholder: 'Utilize as suas próprias palavras...',
        whatHappenedText:
          'Nas suas próprias palavras, descreva o que aconteceu',
      },
      Details: {
        disclaimer:
          'Estes detalhes serão divulgados com o seu relatório. Se deseja permanecer anónimo, certifique-se de que não contêm informações de identificação.',
        emailPlaceholder: 'E-mail (opcional)',
        fullNamePlaceholder: 'Nome completo (opcional)',
        header: 'Os seus dados',
        nonAnonSubtitle:
          'Por favor, forneça o seu nome ou endereço de email. Se quiser receber notificações sobre este relatório, adicione um endereço de email apropriado abaixo.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Nome Completo',
        subtitle:
          'Se quiser receber notificações sobre este relatório, adicione um endereço de email apropriado abaixo.',
      },
      Emotion: {
        description: 'Como é que se sentiu? Qual foi o impacto?',
        header: 'Qual foi o impacto?',
        placeholder: 'Comece a escrever...',
      },
      Evidence: {
        addedHeading: 'Adicionado',
        deletedMessage: 'foi apagado',
        deletedStatus: 'Apagado',
        failedToOpenFileMessage:
          'Falha ao abrir o ficheiro. Por favor, tente novamente.',
        fileStatuses: {
          infectedUpload: 'Sinalizado pela verificação de segurança',
          passedUpload: 'Passou na verificação de segurança',
          pendingUpload: 'Verificação de segurança em progresso',
          readyForDownload: 'Pronto para download',
        },
        mobileErrorMessage:
          'Ficheiros assinalados: contacte o seu gestor de caso',
        nameHeading: 'Nome',
        statusHeading: 'Estado',
        tableTitle: 'Prova',
        webErrorMessage:
          'Ficheiros sinalizados: Se o(s) seu(s) ficheiro(s) foram sinalizados, por favor envie uma mensagem ao gestor de caso.',
      },
      FileUpload: {
        addFiles: 'Adicionar ficheiros',
        addMoreFiles: 'Adicione mais arquivos',
        confirm: 'Confirmar',
        description:
          'Adicionar arquivos como evidência pode ajudar a apoiar a eficiência da resolução pelo seu gestor de caso. Por favor, considere o conteúdo do arquivo (incluindo metadados do arquivo) se deseja permanecer anónimo, e respeite os direitos de outras pessoas e as leis aplicáveis.',
        dragDrop: 'Solte os ficheiros aqui ou',
        errorMessage:
          'O(s) ficheiro(s) falhou(ram) devido a um erro de rede. Clique abaixo para enviar uma mensagem ao seu gestor de caso para assistência.',
        fileLimit: 'Limite de tamanho para cada ficheiro: 100MB',
        fileUploadLimitText: 'Só pode fazer upload de 10 ficheiros',
        header: 'Adicionar evidência',
        helpArticle: 'artigo de ajuda',
        highlighted: 'navegar pelos ficheiros',
        information: 'Tipos de ficheiros suportados',
        moreInformation:
          'Para mais informações, por favor, veja isto <a>artigo de ajuda</a>',
        postSubmissionErrorMessage:
          "Não conseguimos fazer o upload dos seus ficheiros devido a um erro do sistema. Por favor, selecione 'confirmar' novamente.",
        tooltipAudio: 'Áudio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documentos:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Imagens:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Texto:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Vídeo:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'O ficheiro é demasiado grande',
          invalidFileType: 'Tipo de ficheiro não suportado: {{extension}}',
          systemError: 'Erro de sistema',
          tooManyFiles: 'O número máximo de ficheiros é {{maxFiles}}',
        },
        uploadFiles: 'Carregar ficheiros',
      },
      Loading: {
        loading:
          'Por favor aguarde enquanto submetemos o seu relatório a um gestor de caso...',
        postSubmissionLoading:
          'Por favor, aguarde enquanto enviamos o(s) seu(s) arquivo(s)...',
      },
      Location: {
        description: 'Onde é que ocorreu?',
        header: 'Onde é que ocorreu?',
        placeholder: 'Exemplo: no escritório',
      },
      MessageListBox: {
        messageCaseManager: 'Enviar mensagem ao gestor de incidentes',
        report: 'Reportar {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Tradução desativada',
        enableTranslationLabelEnabled: 'Tradução ativada',
        enableTranslationsDescription:
          'Ative as traduções automáticas e leia todas as mensagens de relatório no seu idioma preferido. O idioma traduzido é baseado no idioma selecionado no seu dispositivo.',
        enableTranslationsHeader:
          'Ativar auto-traduções para mensagens de relatório',
        enableTranslationsSubDescriptionv2:
          'Pode alternar entre a língua traduzida e a língua original em cada chat.',
        updateTranslationFailed: 'A atualização da tradução falhou',
        updateTranslationSuccess:
          'Definição de tradução atualizada com sucesso',
      },
      Password: {
        changePasswordHeader: 'Alterar Palavra-passe',
        createNewPassword: 'Crie uma nova palavra-passe',
        createPasswordHeader: 'A sua palavra-passe',
        currentPasswordPlaceholder: 'Introduza a palavra-passe atual',
        description:
          'Uma palavra-passe válida deve ter pelo menos 9 caracteres e incluir uma letra maiúscula e um número',
        enterCurrentPassword: 'Introduza a sua palavra-passe atual',
        forgottenPasswordInstructions:
          'Insira o seu Vault ID alfanumérico (não o seu endereço de email) e endereço de email para redefinir a sua senha.',
        newDescription:
          'Crie uma senha forte para manter a sua conta segura. Comece a digitar para ver as diretrizes abaixo.',
        passwordPlaceholder: 'Criar uma palavra-passe',
        passwordResetRequestedDescription:
          'Se o seu ID Vault existir no nosso sistema, você receberá um email com instruções para redefinir a sua senha.',
        passwordResetRequestedHeader:
          'Pedido de link para redefinição de senha',
        reenterPlaceholder: 'Introduzir novamente a palavra-passe',
        subtitle:
          'Crie uma palavra-passe para submeter este relatório e aceder ao mesmo no futuro',
        yourVaultId: 'O seu ID Vault',
        yourVaultIdPlaceholder:
          'Insira o seu ID Vault (por exemplo, {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Está a denunciar uma pessoa específica ou múltiplas pessoas? Pode indicar quem são ou descrevê-las?',
        header: 'Pessoas envolvidas',
        placeholder:
          'Comece a escrever e use uma vírgula para adicionar vários nomes ou descrições',
      },
      PoweredByVault: 'Desenvolvido por {{company}}',
      PrivacyStatement: 'Declaração de Privacidade do Produto',
      PublicMessageList: {
        myMessages: 'As minhas mensagens',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Provas adicionadas ao relatório existente',
        backToReportId: 'Voltar para o relatório ID: {{reportId}}',
        description:
          'Adicionar arquivos como evidência pode ajudar a apoiar a eficiência de resolução do seu gestor de caso. Por favor, considere o conteúdo do arquivo (incluindo metadados do arquivo) se desejar permanecer anónimo, e respeite os direitos de outras pessoas e as leis aplicáveis. Para mais informações, por favor, veja isto. <a>artigo de ajuda</a>',
        header: 'Adicione evidências adicionais ao relatório',
        vaultTalkOpenCaseHeader: 'Adicione evidências ao seu relatório',
      },
      PublicReport: {
        anonymous: 'Anónimo',
        backToReports: 'Voltar aos relatórios',
        skipped: 'Ignorado',
      },
      PublicReportCard: {
        addEvidence: 'Adicionar provas adicionais',
        messageCaseManager: 'Enviar mensagem ao gestor de incidentes',
        reportId: 'ID do Relatório:',
        submitted: 'Submetido',
        vaultTalkClosedCaseCTA: 'Ver Provas',
        vaultTalkOpenCaseCTA: 'Adicionar Evidência',
        viewAdditionalEvidence: 'Ver evidências adicionais',
        viewReport: 'Ver relatório',
      },
      PublicReportsList: {
        reportingSystem: 'Sistema de relatórios',
      },
      Question: {
        placeholder: 'Comece a digitar...',
        question: 'Forneça detalhes',
        questionText:
          'Por favor, partilhe a sua preocupação, atualização ou consulta connosco.',
      },
      Relationship: {
        header: 'A sua relação com a organização',
        tellUsAbout:
          'Dê-nos informações acerca da sua relação com a organização.',
      },
      ResponsiveNavMenu: {
        messages: 'As minhas mensagens',
        reports: 'Os meus relatórios',
      },
      Site: {
        description: 'Em que local está sediado?',
        header: 'Em que local está sediado?',
        noOptions: 'Nenhum local encontrado',
        other: 'Outro',
        placeholder: 'Procurar um local...',
      },
      SpamPuzzle: {
        dialog: 'Para continuar, resolva este quebra-cabeças',
      },
      SubmissionTypes: {
        reportIssue: 'Selecione uma categoria',
        whatType: 'Selecione a categoria que melhor descreve o seu relatório',
      },
      SubmitSuccess: {
        category: '<bold>Categoria:</bold> {{category}}',
        country: '<bold>País:</bold> {{country}}',
        dateSubmitted: '<bold>Data de submissão:</bold> {{date}}',
        recordYourVaultID: 'Lembre-se desta informação para login',
        successInformation: 'Mais informação',
        successMessage:
          'O seu relatório foi submetido e está pronto para revisão. Quaisquer ficheiros anexados que requerem atenção serão sinalizados após o login. Faça login abaixo para ver as atualizações do relatório e enviar mensagens ao seu gestor de caso.',
        successSanitationMessage:
          'Guarde uma cópia para os seus registos e mantenha o seu Vault-ID em segurança — vai precisar dele para aceder a atualizações e enviar mensagens ao seu gestor de caso.',
        successSanitationTagline:
          'O seu relatório foi submetido e armazenado de forma segura.',
        successThankYou: 'Obrigado pelo seu relatório!',
        viewReport: 'Ver relatório',
      },
      Time: {
        approximateDescription:
          'Lembra-se da hora aproximada em que o evento ocorreu?',
        approximatePlaceholder: 'Exemplo: de manhã, à tarde',
        description: 'Lembra-se da hora em que o evento ocorreu?',
        header: 'A que horas ocorreu?',
        invalidTime: 'O formato da hora tem de ser HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Alterar Palavra-passe',
        closeDialog: 'Fechar caixa de diálogo',
        logout: 'Encerrar sessão',
        messageSettings: 'Configurações de Mensagem',
        userSettings: 'Definições de utilizador',
      },
      Witnesses: {
        description: 'Contou a alguém ou alguém viu o que aconteceu?',
        header: 'Alguma testemunha?',
        placeholder: 'Comece a escrever...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Enviar mensagem',
        title: 'Mensagem para o Gestor de Caso',
        translationHeader: 'Saiba mais sobre traduções automáticas',
      },
      ReportCard: {
        addEvidence: 'Adicione evidência',
        submissionModeVia: 'através de {{submissionMode}}',
        viewEvidence: 'Ver evidência',
      },
      ReportList: {
        yourReports: 'Os Seus Relatórios',
      },
      ReportingActivate: {
        buttonText: 'Continuar',
        description:
          'Se a sua organização o registou para uma conta, enviaremos um email com instruções para completar a configuração.',
        emailInput: 'Email',
        header: 'Insira o seu email de trabalho',
        successAccount:
          'Se a sua organização registou-o para uma conta, enviaremos um email com instruções para concluir a configuração.',
        successEmail:
          'Se não o vir imediatamente, por favor espere alguns minutos e actualize a sua caixa de correio eletrónico.',
        successHeading: 'Obrigado',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Adicione provas ao seu relatório',
        descriptionText:
          'Adicionar ficheiros como evidência pode ajudar a apoiar a eficiência da resolução pelo seu gestor de caso. Por favor, considere o conteúdo do ficheiro (incluindo metadados de ficheiros) se desejar permanecer anónimo e respeitar os direitos dos outros indivíduos e as leis aplicáveis. Para mais informações, veja este <a>artigo de ajuda</a>',
        emptyMessage: 'Sem evidências adicionais carregadas',
      },
      ReportingChangePassword: {
        back: 'De volta',
        description:
          'Crie uma senha forte para manter a sua conta segura. Comece a escrever para ver as diretrizes abaixo.',
        errorToast: 'Não é possível criar a senha, token inválido.',
        header: 'Alterar Senha',
        incorrectCurrentPassword:
          'A palavra-passe atual está incorreta. Por favor, verifique-a e tente novamente.',
        invalidToken: 'Token inválido',
        passwordUpdated: 'Senha atualizada',
        passwordUpdatedDescription:
          'A sua palavra-passe foi atualizada com sucesso. Obrigado por dar este passo para manter os seus dados seguros!',
        passwordUsedBefore: 'Não é permitido reutilizar senhas',
        passwordUsedBeforeDescription:
          'Para a sua segurança, não pode reutilizar nenhuma das suas últimas seis senhas. Por favor, escolha uma nova senha única para manter a sua conta segura e tente novamente.',
        toastDescription:
          'A sua senha foi atualizada com sucesso. Obrigado por dar este passo para manter os seus dados seguros!',
        toastMessage: 'Senha atualizada',
        updatePasswordCTA: 'Atualizar senha',
      },
      ReportingConnect: {
        cancelButton: 'Cancelar',
        connectButton: 'Conectar',
        disclaimer:
          'Conectar a sua conta Slack com a sua conta Vault garante uma conexão segura e privada.<br /><br />Ao conectar, poderá denunciar má conduta ou fazer uma pergunta diretamente no Slack. Você sempre terá a opção de denunciar anonimamente após a conexão. A sua privacidade e segurança são as nossas principais prioridades.',
        heading:
          'Vault Platform está a solicitar permissão para aceder à sua conta Slack da {{organisationName}}',
        listHeading: 'O que o Vault será capaz de fazer?',
        permissionIdentity: {
          extraInfo:
            'Vault terá a capacidade de visualizar a identidade do seu utilizador do Slack',
          heading: 'Ver informações sobre a identidade de um usuário',
        },
        permissionNotifications: {
          extraInfo:
            'Vault poderá enviar-lhe notificações para a sua conta Slack, sobre quaisquer atualizações num relatório submetido ou numa questão.',
          heading: 'Enviar-te notificações',
        },
        permissionOverview: {
          extraInfo:
            'O Vault apresentará uma visão geral de todas as submissões na página inicial',
          heading: 'Visão geral das submissões',
        },
        permissionSubmitReport: {
          extraInfo:
            'Isso concederá a Vault permissão para enviar um relatório ou fazer uma pergunta, diretamente para a sua organização, pelo Slack.',
          heading: 'Submeta um relatório ou pergunta em seu nome',
        },
        successfulConnectionDescription:
          'A sua conta Vault e conta Slack estão agora conectadas. Agora pode fechar este separador e voltar para o Slack.',
        successfulConnectionHeading: 'Conectado com sucesso',
        unsuccessfulConnectionDescription:
          'Algo correu mal. Por favor, feche este separador e volte ao Slack para tentar novamente.',
        unsuccessfulConnectionHeading: 'Falha na conexão',
      },
      ReportingForgotPassword: {
        description:
          'Insira o endereço de email associado à sua conta e nós enviaremos um link para redefinir a sua senha.',
        heading: 'Senha esquecida',
        invalidTokenError: 'Não é possível criar senha, token inválido.',
        passwordReuseError: 'Reutilização de senha não permitida',
        passwordReuseErrorDescription:
          'Para a sua segurança, não pode reutilizar nenhuma das suas últimas seis senhas. Por favor, escolha uma nova senha única para manter a sua conta segura e tente novamente.',
        sendLink: 'Enviar link de redefinição',
        sendLinkFailure: 'Algo correu mal',
        sendLinkFailureDescription:
          'Volte para o <a>Centro de Reportagem</a> e tente novamente. Se o problema persistir, entre em contacto connosco em <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link de redefinição de senha enviado',
        sendLinkSuccessDescription:
          'Enviamos um link de redefinição de senha para {{email}}',
        updatePasswordSuccess: 'Senha atualizada',
        updatePasswordSuccessDescription:
          'A sua palavra-passe foi atualizada com sucesso. Obrigado por dar este passo para manter os seus dados seguros!',
      },
      ReportingLogin: {
        accountFrozen: 'A conta está congelada',
        accountLocked:
          'O login foi tentado demasiadas vezes de forma incorreta. A conta está bloqueada por até 1 hora. Não é possível redefinir a senha durante este período.',
        accountLockedPermanently:
          'A sua conta foi bloqueada. Utilize a opção de redefinição de senha para recuperar o seu acesso ou entre em contato com o administrador do sistema para obter mais ajuda.',
        createAccountCTA: 'Registe-se para uma conta',
        currentPassword: 'Senha Atual',
        emailLabel: 'O seu Email',
        forgotPassword: 'Esqueceu a sua senha?',
        loginButton: 'Iniciar sessão',
        newPasswordPlaceholder: 'Nova senha',
        passwordFailMessage:
          'Volte para o aplicativo Vault no Slack e tente novamente. Se o problema persistir, entre em contato conosco em techsupport@vaultplatform.com',
        passwordFailTitle: 'Algo correu mal',
        passwordLabel: 'A sua Palavra-passe',
        passwordPlaceholder: 'Insira a sua senha',
        passwordResetRequired: 'É necessário redefinir a senha',
        passwordSuccessfullySetMessage:
          'Volte para o aplicativo Vault no Slack e autentique com sua nova senha para continuar de onde parou.',
        passwordSuccessfullySetTitle: 'Senha definida com sucesso',
        reenterPlaceholder: 'Reinsira a senha',
        title: 'Reporter Hub',
        tooltip:
          'Se nunca definiu uma senha para a aplicação Vault, siga aqui para começar. Se esqueceu a sua senha, use o link "Esqueceu a senha" abaixo.',
        usernameLoginFailed:
          'Falha no login, nome de usuário ou senha incorretos',
      },
      ReportingReset: {
        failureDescription:
          'Volte para o aplicativo Vault no Slack e tente novamente. Se o problema persistir, entre em contato conosco em <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Algo correu mal',
        successDescription:
          'Volte para o aplicativo Vault no Slack e autentique-se com sua nova senha para continuar de onde parou',
        successHeading: 'Senha definida com sucesso',
      },
      noReports: {
        description:
          'Todos os relatórios submetidos serão mostrados aqui. Saiba mais sobre as formas como você pode submeter um relatório em',
        descriptionHelpArticle: 'este artigo de ajuda',
        errorDescription:
          'Estamos a ter dificuldades em carregar os seus relatórios. Por favor, tente atualizar a página.',
        errorDescriptionSecondary:
          'Se isso não funcionar, por favor entre em contacto connosco em',
        errorTitle: '⚠️ Oops, algo correu mal',
        title: 'Ainda não tem relatórios',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Ative as traduções automáticas e leia todas as mensagens de relatório no seu idioma preferido. O idioma traduzido é baseado no idioma selecionado no seu dispositivo.',
          autoTranslationDescription2:
            'Pode alternar entre a língua traduzida e a língua original em cada conversa.',
          autoTranslationTitle:
            'Ative as traduções automáticas para mensagens de relatório',
          header: 'Configurações de Mensagem',
          subHeader: 'Configure como as mensagens são exibidas',
        },
        notificationSettings: {
          emailDescription:
            'Receba notificações por email para atualizações importantes nos seus relatórios',
          emailTitle: 'Notificações por Email',
          header: 'Configurações de Notificações',
          subHeader: 'Configure como recebe notificações',
        },
        title: 'Configurações',
        updatedSettingsFailure: 'Falha ao atualizar as suas configurações',
        updatedSettingsSuccess: 'Configurações atualizadas com sucesso',
      },
    },
    validators: {
      passwordLength: 'A palavra-passe tem de ter, pelo menos, 9 caracteres',
      passwordLowercase:
        'A palavra-passe tem de ter, pelo menos, 1 letra minúscula',
      passwordMissMatch:
        'Os campos da palavra-passe e da confirmação têm de corresponder.',
      passwordNumeric: 'A palavra-passe tem de ter, pelo menos, 1 número',
      passwordUppercase:
        'A palavra-passe tem de ter, pelo menos, 1 letra maiúscula',
    },
    validatorsNew: {
      passwordLength: 'Entre 10 e 30 caracteres',
      passwordLowercase: 'Pelo menos uma letra minúscula',
      passwordMissMatch: 'As senhas não coincidem',
      passwordNumeric: 'Pelo menos um número',
      passwordSpecialCharacter: 'Pelo menos um caractere especial',
      passwordUppercase: 'Pelo menos uma letra maiúscula',
    },
  },
};

export default translations;
